<div *ngIf="controllaZero()">
    <mat-radio-button value="ZERO">
      <span class="wrap-mat-radio-label">
        {{'carrello.pagaZero' | translate}}
      </span>
    </mat-radio-button>
    <span class="noteRadio">
      {{'carrello.pagaZeroNote' | translate}}
    </span>
  </div>
